import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';
import type { ListParams, PaginatedData, Country, CountryFormData } from '@/shared/types';

const BASE = '/admin/countries';

export const countryApi = {
  list: async (params: ListParams): Promise<PaginatedData<Country>> => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getById: async (id: string | number): Promise<Country> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },

  create: async (data: CountryFormData): Promise<Country> => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data;
  },

  update: async (id: string | number, data: CountryFormData): Promise<Country> => {
    const res = await apiClient.patch(`${BASE}/${id}`, data);
    return res.data?.data;
  },

  delete: async (id: string | number): Promise<void> => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },
};
